import { userAlertsReducer, UserAlertsSagasListener } from "./UserAlerts";
import {
  UserAlertSettingSagasListener,
  userAlertsSettingsReducer,
} from "./UserAlertSettings";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";

const sagaMiddleware = createSagaMiddleware();
const middleware = applyMiddleware(sagaMiddleware);

export const userAlertsStoreReducer = combineReducers({
  userAlerts: userAlertsReducer,
  userAlertsSettings: userAlertsSettingsReducer,
});

export const userAlertsStore = createStore(
  userAlertsStoreReducer,
  compose(middleware),
);
[UserAlertsSagasListener, UserAlertSettingSagasListener].forEach(
  sagaMiddleware.run,
);

export type UserAlertsState = ReturnType<typeof userAlertsStoreReducer>;
